module.exports = __webpack_public_path__ + "static/media/logo-google.4af031c1.svg";